import { render } from "./AddPlantCredentials.vue?vue&type=template&id=952af684&scoped=true"
import script from "./AddPlantCredentials.vue?vue&type=script&lang=js"
export * from "./AddPlantCredentials.vue?vue&type=script&lang=js"

import "./AddPlantCredentials.vue?vue&type=style&index=0&id=952af684&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-952af684"]])

export default __exports__